import { useContext, useEffect, useState } from "react";
import { useCommanData } from "../../../../contexts/commanData.context";
import { useSearchParams } from "react-router-dom";
import { UserContext } from "../../../../contexts/user.context";
import { useTranslation } from "react-i18next";
import { API_LINK, Get, handleError, Post } from "../../../../utils/fetch.util";
import { toast } from "react-toastify";

const defaultToggle = {
  stages: false,
  date: false,
  count: true,
};

const defaultFilterValues = {
  stages: [],
  startDate: "",
  endDate: "",
};

export default function useReportsAnswersSelects() {
  const { getValidToken, userData } = useContext(UserContext);
  const { sectors, segments } = useCommanData();
  const [searchParams, setSearchParams] = useSearchParams();
  const { t } = useTranslation();

  const [reports, setReports] = useState<any[]>([]);
  const [report, setReport] = useState<any>(null);
  const [nestedTable, setNestedTable] = useState<any>(null);
  const [reportsCount, setReportsCount] = useState<number>(0);
  const [reportId, setReportId] = useState<number | null>(null);
  const [reportAnswers, setReportAnswers] = useState<any[]>([]);
  const [reportsCategories, setReportsCategories] = useState<any[]>([]);
  const [reportsOrVoiceReports, setReportsOrVoiceReports] = useState("");
  const [searchValue, setSearchValue] = useState<string>("");
  const [reportAnswersFlow, setReportAnswersFlow] = useState<any[]>([]);
  const [versionId, setVersionId] = useState<number | null>(null);
  const [versionsCount, setVersionsCount] = useState<number>(0);
  const [reportVersion, setReportVersion] = useState<number>(1);
  const [isLoading, setIsLoading] = useState("");
  const [voiceReports, setVoiceReports] = useState<any[]>([]);
  const [flowIDs, setFlowIDs] = useState<any[]>([]);
  const [formIDs, setFormIDs] = useState<any[]>([]);

  const [toggleFilter, setToggleFilter] = useState<boolean>(false);
  const [exportLoading, setExportLoading] = useState<boolean>(false);
  const [toggleExportModal, setToggleExportModal] = useState<boolean>(false);
  const [filterValues, setFilterValues] = useState<any>(defaultFilterValues);
  const [toggleOptions, setToggleOptions] = useState<any>(defaultToggle);

  const [toggleExportOptions, setToggleExportOptions] =
    useState<boolean>(false);
  const [exportMode, setExportMode] = useState<"all" | "view" | "select">(
    "all"
  );
  const [filteredForms, setFilteredForms] = useState<any[]>([]);
  const [selectedFormIds, setSelectedFormIds] = useState<string[]>([]);
  const [selectedQuestionIds, setSelectedQuestionIds] = useState<number[]>([]);
  const [reportAnswerImages, setReportAnswerImages] = useState<string[]>([]);

  // const [selectedService, setSelectedService] = useState<any>(null);
  const [previewImage, setPreviewImage] = useState<string>("");
  const page = searchParams.get("page") || "1";
  const itemsPerPage = searchParams.get("itemsPerPage") || "25";
  const sort = searchParams.get("sort");

  // const servicesOptions =
  //   userData[0]?.userServices?.map((service: any) => {
  //     return {
  //       value: service?.asdc_client_service_id,
  //       label: service?.asdc_client_service_name,
  //     };
  //   }) || [];

  const sites =
    userData[0]?.user_sites_relationShip?.map((site: any) => site?.site) || [];

  const filterdSectors =
    sectors.filter((sector: any) => {
      return (
        userData[0]?.user_sites_relationShip.filter(
          (site: any) =>
            site.site.asdc_client_sector_id === sector.asdc_client_sector_id
        ).length > 0 && sector
      );
    }) || [];

  const filterdSegments =
    segments.filter((segment: any) => {
      return (
        filterdSectors
          .map((sector: any) => sector.segment_id)
          .includes(segment.id) && segment
      );
    }) || [];

  const defaultSiteId = sites.length === 1 ? sites[0]?.site_id : null;

  const defaultSectorId = defaultSiteId
    ? sites.find((site: any) => site.site_id === defaultSiteId)
        ?.asdc_client_sector_id
    : filterdSectors?.length === 1
      ? filterdSectors[0]?.asdc_client_sector_id
      : null;

  const defaultSegmentId = defaultSectorId
    ? filterdSectors.find(
        (sector: any) => sector.asdc_client_sector_id === defaultSectorId
      )?.segment_id
    : filterdSegments?.length === 1
      ? filterdSegments[0]?.id
      : null;

  const [sitevalue, setSiteValue] = useState<number | null>(
    searchParams.get("siteId")
      ? +(searchParams.get("siteId") as any)
      : defaultSiteId
  );
  const [sectorValue, setSectorValue] = useState<number | null>(
    searchParams.get("sectorId")
      ? +(searchParams.get("sectorId") as any)
      : defaultSectorId
  );
  const [segmentValue, setSegmentValue] = useState<number | null>(
    searchParams.get("segmentId")
      ? +(searchParams.get("segmentId") as any)
      : defaultSegmentId
  );

  const reportsCategoreisOptions = [
    { value: "static", label: t("static_reports") },
    { value: "dynamic", label: t("qr_reports") },
    { value: "VoiceReport", label: t("voice_reports") },
  ];

  const sitesOptions =
    userData[0]?.user_sites_relationShip
      ?.filter((site: any) => {
        if (sectorValue) {
          return site.site.asdc_client_sector_id === sectorValue;
        } else {
          return true;
        }
      })
      .map((site: any) => ({
        value: site?.site?.site_id,
        label: site?.site?.site_name,
      })) || [];

  const sectorsOptions =
    filterdSectors
      .filter((sector: any) => sector.segment_id == segmentValue)
      ?.map((sector: any) => {
        return {
          value: sector.asdc_client_sector_id,
          label: sector.asdc_client_sector_name,
        };
      }) || [];

  const segmentsOptions =
    filterdSegments.map((segment) => ({
      label: segment.name,
      value: segment.id,
    })) || [];

  const reportsOptions =
    reports.map((report: any) => ({
      value: report?.report_id,
      label: report?.report_title,
    })) || [];

  const versionOptions =
    versionsCount > 0
      ? [...Array(versionsCount).keys()].map((version: any) => ({
          value: version + 1,
          label: "V. " + (version + 1),
        }))
      : [];

  const nestedTableConverter = (report: any, flowId: string) => {
    if (!report) return null;
    let newReport = {
      ...report,
      report_type: report?.report_type + "_nested",
      answers: {},
    };
    const answers = report?.answers?.find(
      (answer: any) => answer.flow_id === flowId
    );
    const stages =
      report?.report_type === "follow_up"
        ? ["opened", "actions", "closed"]
        : ["opened", "closed"];
    stages.forEach((stage: any, index: number) => {
      answers[stage]?.forEach((answer: any) => {
        newReport.answers[answer.form_id] = { ...answer, order: index };
      });
    });
    // console.log(newReport, "newReport");
    return newReport;
    // return report;
  };

  const handleReset = () => {
    setToggleFilter(false);
    setFilterValues(defaultFilterValues);
    setSearchValue("");
    setToggleOptions(defaultToggle);
    setSelectedQuestionIds([]);
    setSelectedFormIds([]);
    setSearchParams((prev: any) => {
      prev.set("page", "1");
      prev.set("itemsPerPage", "25");
      return prev;
    });
  };

  function getDuration(start: any, end: any) {
    // Parse the input date strings
    const startDate: any = new Date(start);
    const endDate: any = new Date(end);

    // Calculate the difference in milliseconds
    const diffMs = endDate - startDate;

    // Handle invalid dates or negative durations
    if (isNaN(diffMs) || diffMs < 0) {
      return "Invalid input";
    }

    // Calculate days, hours, minutes, and seconds
    const days = Math.floor(diffMs / (24 * 60 * 60 * 1000));
    const hours = Math.floor(
      (diffMs % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000)
    );
    const minutes = Math.floor((diffMs % (60 * 60 * 1000)) / (60 * 1000));
    const seconds = Math.floor((diffMs % (60 * 1000)) / 1000);

    // Build the formatted duration string
    const parts = [];
    if (days > 0) parts.push(`${days}d`);
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0) parts.push(`${minutes}m`);
    if (seconds > 0 && parts.length === 0) parts.push(`${seconds}s`); // Include seconds only if no larger units exist

    return parts.join(" ");
  }

  const getReportVersion = async (versionNumber: number) => {
    const id = searchParams.get("reportId");
    const query = [];
    query.push(`report_id=${id}`);
    query.push(`version=${versionNumber}`);
    query.push(`page=${page || "1"}`);
    query.push(`pageItemsCount=${itemsPerPage || "25"}`);
    query.push(`site_id=${sitevalue}`);
    const res = await Get(
      `reports/get-all-report-versions?${query.join("&")}`,
      getValidToken()
    );
    if (!res.error && res.data) {
      handleError(res);
    }
    setReportsCount(res.count || 0);
    setReport(res.data.find((item: any) => item.version === versionNumber));
    const answersByFormId: Record<string, Array<any>> = {};
    const answersByFlowId: Record<string, Array<any>> = {};
    res.data
      .find((item: any) => item.version === versionNumber)
      ?.report_answers.forEach((answer: any) => {
        const formId: string = answer.FormId;
        if (!answersByFormId[formId]) {
          answersByFormId[formId] = [];
        }
        answersByFormId[formId].push(answer);
      });
    const sortedReportAnswers = Object.values(answersByFormId).map(
      (answerForm: any) => {
        return answerForm.sort((a: any, b: any) => {
          return a.report_question_id - b.report_question_id;
        });
      }
    );
    res.data
      .find((item: any) => item.version === versionNumber)
      ?.report_answers.forEach((answer: any) => {
        const flowId: string = answer.flowId;
        if (!answersByFlowId[flowId]) {
          answersByFlowId[flowId] = [];
        }
        answersByFlowId[flowId].push(answer);
      });
    setFlowIDs(
      Object.values(answersByFlowId).map((flowID: any) => flowID[0].flowId)
    );
    setFormIDs(
      Object.values(answersByFlowId)
        .map((flowID: any) => flowID[0].flowId)
        .map((flowID: any) => {
          return Object.values(answersByFormId).filter(
            (formId: any) => formId[0].flowId === flowID
          );
        })
    );
    setReportAnswers(
      sortedReportAnswers.sort((a: any, b: any) => {
        const aUpdatedAtTime = new Date(
          `${a[0].Date?.split("T")[0]}T${a[0].Time}`
        );
        const bUpdatedAtTime = new Date(
          `${b[0].Date?.split("T")[0]}T${b[0].Time}`
        );
        return bUpdatedAtTime.getTime() - aUpdatedAtTime.getTime();
      })
    );
    res.data?.find((item: any) => item.version === versionNumber)
      ?.report_type === "follow_up" &&
      setReportAnswersFlow(Object.values(answersByFlowId));
  };

  const handleSelectFormIds = (FormId: any, rest?: boolean) => {
    if (rest) {
      setSelectedFormIds([]);
      return;
    }
    if (selectedFormIds.includes(FormId)) {
      setSelectedFormIds(selectedFormIds.filter((id) => id !== FormId));
    } else {
      setSelectedFormIds((prev) => [...prev, FormId]);
    }
  };

  const handleSelectQuestionIds = (question_id: any, rest?: boolean) => {
    if (rest) {
      setSelectedQuestionIds([]);
      return;
    }
    if (selectedQuestionIds.includes(question_id)) {
      setSelectedQuestionIds(
        selectedQuestionIds.filter((id) => id !== question_id)
      );
    } else {
      setSelectedQuestionIds((prev) => [...prev, question_id]);
    }
  };

  useEffect(() => {
    const getReportsCategories = async () => {
      setIsLoading("reportsCategories");
      const res = await Get(
        "reports/get-all-reports-categories",
        getValidToken()
      );
      setIsLoading("");
      if (res.error && !res.data) {
        handleError(res);
        return;
      }
      setReportsCategories(res.data);
    };
    !sitevalue && setReportsCategories([]);
    !sitevalue && setReportsOrVoiceReports("");
    !sitevalue && setReports([]);
    !sitevalue && setVoiceReports([]);
    sitevalue && getReportsCategories();
    document.title = t("reports_answers");
  }, [sitevalue]);

  useEffect(() => {
    const getReports = async () => {
      setIsLoading("reports");
      const res = await Get(
        `reports/get-all-reports${
          sitevalue && reportsOrVoiceReports.length > 0
            ? `?site_id=${sitevalue}&report_category=${reportsOrVoiceReports}&disable_timeline=yes`
            : ""
        }`,
        getValidToken()
      );
      setIsLoading("");
      if (res.error && !res.data) {
        handleError(res);
        return;
      }
      setReports(res.data.filter((report: any) => report?.versionId > 0));
    };
    const getVoiceReports = async () => {
      setIsLoading("voiceReports");
      const res = await Get(
        `voice-report/get-voice-reports-for-site${
          sitevalue ? `?site_id=${sitevalue}` : ""
        }`,
        getValidToken()
      );
      setIsLoading("");
      if (res.error && !res.data) {
        handleError(res);
        return;
      }
      setVoiceReports(res.data);
    };
    ((!reportsOrVoiceReports.includes("static") &&
      !reportsOrVoiceReports.includes("dynamic")) ||
      reportsOrVoiceReports.includes("static")) &&
      setReports([]);
    !reportsOrVoiceReports.includes("VoiceReport") && setVoiceReports([]);
    (reportsOrVoiceReports.includes("static") ||
      reportsOrVoiceReports.includes("dynamic") ||
      reportsOrVoiceReports.includes("static")) &&
      getReports();
    reportsOrVoiceReports.includes("VoiceReport") && getVoiceReports();
  }, [reportsOrVoiceReports]);

  useEffect(() => {
    sitesOptions.length === 1 && setSiteValue(sitesOptions[0].value);
    setReportsOrVoiceReports(
      (searchParams.get("reportCategory") as string) ?? ""
    );

    if (searchParams.get("reportCategory") as string) {
      const report_id = searchParams.get("reportId") ?? 0;
      setReportId(Number(report_id) || null);

      const selectedReport = reports?.find(
        (report) => Number(report.report_id) === Number(report_id)
      );

      if (selectedReport) {
        // console.log(selectedReport, "selectedReport")
        setVersionId(selectedReport.versionId || null);
        setVersionsCount(selectedReport.version || null);
        setReportVersion(selectedReport.version || null);
      }
    }
  }, [sectorValue, sitevalue, reportsOrVoiceReports, reports]);

  const exportExceel = async (versionId: number, exportImages?: boolean) => {
    setExportLoading(true);
    const forms = filteredForms.map((answerForm: any) => answerForm[0].FormId);
    const formsIds = exportMode === "all" ? [] : selectedFormIds;
    const data: any = {
      versionId,
      form_ids: formsIds.length > 0 ? formsIds : [],
      question_ids:
        selectedQuestionIds.length > 0 && exportMode === "select"
          ? selectedQuestionIds
          : [],
      site_id: sitevalue,
      version: reportVersion,
      images: exportImages,
    };
    const query: any = [];

    if (exportMode === "view" && +itemsPerPage > 0) {
      query.push(`page=${page}`);
      query.push(`pageItemsCount=${itemsPerPage}`);
    }
    if (searchValue.length > 0) {
      query.push(`search=${searchValue}`);
      query.push(`search_field=all`);
    }
    if (filterValues.startDate.length > 0) {
      data["start_date"] = filterValues.startDate;
    }
    if (filterValues.endDate.length > 0) {
      data["end_date"] = filterValues.endDate;
    }

    const res = await Post(
      `reports/export-report?${query.join("&")}`,
      data,
      getValidToken()
    );

    if (res.error && !res.data) {
      setExportLoading(false);
      handleError(res);
      return;
    }

    setExportLoading(false);
    setToggleExportModal(false);
    setToggleExportOptions(false);
    window.open(API_LINK + res.data?.sheet?.url, "_blank");
  };

  const getReport = async () => {
    setIsLoading("report");
    if(versionId == 0) {
      setIsLoading("");
      return toast.error("Version Id Is Missing")
    }

    if (reportId && versionId !== null && reportVersion) {
      const data: any = {
        versionId,
        version: reportVersion,
        site_id: sitevalue,
        // service_name: servicesOptions?.find(
        //   (service: any) => service?.value == selectedService
        // )?.label,
      };
      const query = [];

      if (+itemsPerPage > 0) {
        query.push(`page=${page}`);
        query.push(`pageItemsCount=${itemsPerPage}`);
      }
      if (searchValue.length > 0) {
        query.push(`search=${searchValue}`);
        query.push(`search_field=all`);
      }
      if (filterValues.startDate.length > 0) {
        data["start_date"] = filterValues.startDate;
      }
      if (filterValues.endDate.length > 0) {
        data["end_date"] = filterValues.endDate;
      }

      // if (selectedService) {
      //   query.push(
      //     `service_name=${
      //       servicesOptions?.find(
      //         (service: any) => service.value == selectedService
      //       ).label
      //     }`
      //   );
      // }

      const res = await Post(
        `reports/get-report-for-web?${query.join("&")}`,
        data,
        getValidToken()
      );
      setIsLoading("");
      if (res.error && !res.data) {
        handleError(res);
        return;
      }
      setReportsCount(res.count || 0);
      setReport(res.data);
    }
    setIsLoading("");
  };
  useEffect(() => {
    getReport();
  }, [
    reportId,
    versionId,
    versionsCount,
    itemsPerPage,
    page,
    reportVersion,
    // selectedService,
    filterValues.startDate,
    filterValues.endDate,
  ]);

  return {
    handleReset,
    reportsCount,
    getReport,
    segmentsOptions,
    sectorsOptions,
    sitesOptions,
    sectorValue,
    setSectorValue,
    sitevalue,
    setSiteValue,
    segmentValue,
    setSegmentValue,
    reportsCategoreisOptions,
    reportsCategories,
    setReportsCategories,
    reportsOrVoiceReports,
    setReportsOrVoiceReports,
    reports,
    setReports,
    voiceReports,
    setVoiceReports,
    reportId,
    setReportId,
    setReport,
    isLoading,
    reportsOptions,
    setVersionId,
    versionId,
    setVersionsCount,
    report,
    toggleFilter,
    setToggleFilter,
    getReportVersion,
    // servicesOptions,
    reportAnswers,
    reportAnswersFlow,
    flowIDs,
    formIDs,
    toggleExportModal,
    setToggleExportModal,
    exportLoading,
    setExportLoading,
    // selectedService,
    // setSelectedService,
    versionsCount,
    versionOptions,
    reportVersion,
    setReportVersion,
    searchValue,
    setSearchValue,
    toggleOptions,
    setToggleOptions,
    filterValues,
    setFilterValues,
    exportExceel,
    exportMode,
    setExportMode,
    toggleExportOptions,
    setToggleExportOptions,
    selectedQuestionIds,
    selectedFormIds,
    handleSelectQuestionIds,
    handleSelectFormIds,
    reportAnswerImages,
    setReportAnswerImages,
    sites,
    previewImage,
    setPreviewImage,
    nestedTable,
    setNestedTable,
    nestedTableConverter,
    getDuration,
    sort,
  };
}
